import { render, staticRenderFns } from "./AnchorPointCreator.vue?vue&type=template&id=6ba9ced4&scoped=true&"
import script from "./AnchorPointCreator.vue?vue&type=script&lang=js&"
export * from "./AnchorPointCreator.vue?vue&type=script&lang=js&"
import style0 from "./AnchorPointCreator.vue?vue&type=style&index=0&id=6ba9ced4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba9ced4",
  null
  
)

export default component.exports